<template>
  <button class="btn obituary life-story-cta" type="button" @click="play">
    <slideshow-icon name="play" />
    <span v-text="texts.playLife" />
  </button>
</template>

<script lang="ts" setup>
  import { openViewer, slideshowTexts } from "../../composables/useSlideshow";
  import SlideshowIcon from "../Slideshow/SlideshowIcon.vue";

  const texts = slideshowTexts();

  function play() {
    openViewer({ kind: "life", source: "mobile_navigation" });
  }
</script>
